import mainViewMixin from './mainViewMixin';
export default {
  name: 'ViewNiotaClassicServiceBuilders',
  mixins: [mainViewMixin],
  data: function () {
    return {};
  },
  computed: {
    headerBG() {
      return './img/nr.png';
    },
    buttonsList() {
      return [];
    }
  },
  methods: {
    pushToRouter(path) {
      this.$router.push({
        path: path
      });
    }
  }
};